
































































































































































const CloseAccountConfirmationText = "yes";

import {
  Vue,
  Component, Prop, Watch,
} from "@/shared/vuepack";
import {
  InvestmentManagementType,
  DrivewealthWizardStep,
  DrivewealthAccountSummary,
  ActivityHistoryElement,
  PendingActivity
} from "@/shared/types";
import VueRouter from "vue-router";

import DisclosureLinks from "./DisclosureLinks.vue";
import DayTradeListing from "@/shared/components/investments/drivewealth/DayTradeListing.vue";
import RiskDisclaimer from "@/shared/components/investments/drivewealth/RiskDisclaimer.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import * as RouteNames from "@/employee/route-names";
import * as drivewealth from "@/shared/custodianSettings/drivewealthTypes";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import * as SharedRoutes from "@/shared/route-names";
import { useNotifierStore } from "@/shared/store/notifier";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useRiskToleranceQuestionnaireStore } from "@/shared/store/riskToleranceQuestionnaire";
import { useThemeStore } from "@/shared/store/theme";

@Component({
  components: {
    DisclosureLinks,
    DayTradeListing,
    RiskDisclaimer,
    GenericLoadingSpinner
  }
})
export default class Preferences extends Vue {
  $router: VueRouter;
  RouteNames = RouteNames;
  SharedRoutes = SharedRoutes;
  InvestmentManagementType = InvestmentManagementType;
  DrivewealthWizardStep = DrivewealthWizardStep;

  featureFlagStore = useFeatureFlagStore();
  drivewealthWizardStore = useDrivewealthWizardStore();
  drivewealthStore = useDrivewealthStore();
  signingDocumentStore = useSigningDocumentStore();
  notifierStore = useNotifierStore();
  custodianSettingsStore = useCustodianSettingsStore();
  riskToleranceQuestionnaireStore = useRiskToleranceQuestionnaireStore();
  themeStore = useThemeStore();

  closeAccountProcessing = false;
  isCloseButtonDisabled = false;
  showConfirmCloseModal = false;
  confirmCloseText = null;
  isAccountNumberMasked = true;

  @Prop() accountId: number;


  mounted (): void {
    if (this.featureFlagStore.flags.bend15911EnableDrivewealthMultiAccountViews) {
      this.drivewealthStore.loadAccountSummariesV2({});
      this.riskToleranceQuestionnaireStore.getUserRtqEligibilityResponse();
    }

    if (this.accountId) {
      this.drivewealthStore.getAccountSummaryV2({ username: null, partnerId: null, dwAccountId: this.accountId });

      this.drivewealthStore.loadPendingActivityByAccount(
          { username: null, partnerId: null, accountId: this.accountId });
      this.drivewealthStore.getAccountV2({ username: null, partnerId: null, accountId: this.accountId });
    } else {
      this.drivewealthStore.loadDefaultAccount();
    }
    this.drivewealthWizardStore.loadAllowedInvestmentAccountTypes({});
    this.loadSignedDocumentKey();
  }

  @Watch("accountTypeKey")
  loadSignedDocumentKey () {
    this.signingDocumentStore.getSignedDocumentKey(this.accountTypeKey);
  }

  get isLoaded (): boolean {
    let v2Loaded = true;
    let isRtqEligibilityLoaded = true;
    if (this.accountId) {
      v2Loaded = this.drivewealthStore.accountSummaryV2Loaded(this.accountId) &&
        this.pendingActivityLoadedForAccount;
    }
    let accountSummariesV2Loaded = true;
    if (this.featureFlagStore.flags.bend15911EnableDrivewealthMultiAccountViews) {
      accountSummariesV2Loaded = this.drivewealthStore.accountSummariesV2Loaded;
      isRtqEligibilityLoaded = this.riskToleranceQuestionnaireStore.isRtqEligibilityLoaded;
    }

    return this.featureFlagStore.featureFlagsAvailable
        && this.drivewealthWizardStore.enrollmentTypeLoaded
        && this.drivewealthStore.drivewealthLoaded
        && this.signingDocumentStore.isSignedKeyLoaded
        && v2Loaded
        && this.drivewealthStore.isAllowedInvestmentAccountTypesLoaded
        && accountSummariesV2Loaded
        && isRtqEligibilityLoaded;
  }

  get investmentAccountNumber () {
    let investmentAccountNumber = "NOT FOUND";

    if (this.accountId) {
      const accountSummary = this.drivewealthStore.accountSummaryById(this.accountId);
      if (accountSummary) {
        investmentAccountNumber = accountSummary.accountNumber;
      }
    }

    if (this.isAccountNumberMasked) {
      return "*".repeat(investmentAccountNumber.length);
    }

    return investmentAccountNumber;
  }

  get disclosureDocumentKey (): string {
    return this.featureFlagStore.flags.bend15067EnableAdvisorAgreementsByType ?
        drivewealth.advisoryDocumentKeyMap[this.accountTypeKey] :
        drivewealth.advisoryDocumentKeyMapOld[this.accountTypeKey];
  }

  get displayDrivewealthQuestionnaireLink (): boolean {
    return !this.accountId &&
      this.drivewealthStore.isAccountManagementType(InvestmentManagementType.Managed);
  }

  get displayDrivewealthQuestionnaireLinkV2 (): boolean {
    return this.accountId &&
      this.drivewealthStore.isAccountManagementType(InvestmentManagementType.Managed, this.accountId);
  }

  get displayCuratedRtqLink (): boolean {
    if (this.accountId) {
      return this.riskToleranceQuestionnaireStore.userRtqEligibilityResponse.curatedRtqEnabledByEmployerOrPartner
        && this.riskToleranceQuestionnaireStore.userRtqEligibilityResponse.hasExistingRtqAndCanRetake
        && this.drivewealthStore.isAccountManagementType(InvestmentManagementType.Advisory, this.accountId);
    }

    return false;
  }

  get accountType (): string {
    return this.drivewealthStore.accountManagementTypeTitle(this.accountId);
  }

  get accountTypeKey (): string {
    return this.drivewealthStore.accountManagementType(this.accountId);
  }

  get documentKey (): string {
    return this.signingDocumentStore.signedKey || this.disclosureDocumentKey;
  }


  get hasAdvisory (): boolean {
    return this.drivewealthWizardStore.enrollmentType && this.drivewealthWizardStore.enrollmentType.hasAdvisory;
  }

  get hasRiaManaged (): boolean {
    return this.featureFlagStore.flags.drivewealthAllowManagedSignup && this.drivewealthWizardStore.enrollmentType &&
        this.drivewealthWizardStore.enrollmentType.hasRiaManaged;
  }


  get hasSelfDirected (): boolean {
    return this.featureFlagStore.flags.drivewealthAllowSelfSignup && this.drivewealthWizardStore.enrollmentType &&
        this.drivewealthWizardStore.enrollmentType.hasSelfDirected;
  }

  get canSwitchAccountManagementType (): boolean {
    if (this.drivewealthStore.isAccountManagementType(InvestmentManagementType.Managed)) {
      return this.hasAdvisory || this.hasSelfDirected;
    }
    if (this.drivewealthStore.isAccountManagementType(InvestmentManagementType.Advisory)) {
      return this.hasRiaManaged || this.hasSelfDirected;
    }
    return this.hasAdvisory || this.hasRiaManaged;
  }

  get hasHoldings (): boolean {
    if (this.accountId) {
      const accountSummary = this.drivewealthStore.accountSummaryById(this.accountId);
      if (accountSummary) {
        return accountSummary.holdings && accountSummary.holdings.length > 0;
      }
    }
    return false;
  }

  get hasInvestmentBalance (): boolean {
    if (this.accountId) {
      const account = this.drivewealthStore.accountSummaryById(this.accountId);

      if (account) {
        return account.displayBalance > 0;
      }
    }
    return true;
  }

  get pendingActivityLoadedForAccount (): boolean {
    if (this.accountId) {
      return this.drivewealthStore.pendingActivityV2Loaded(this.accountId);
    }

    return this.drivewealthStore.pendingActivityLoaded;
  }

  get pendingActivityItemsForAccount (): ActivityHistoryElement[] {
    if (this.accountId) {
      const pendingActivity = this.drivewealthStore.pendingActivityById(this.accountId);

      return pendingActivity ? pendingActivity.pendingOrders : [];
    }

    return this.drivewealthStore.pendingActivity.pendingOrders;
  }

  get hasPendingActivity (): boolean {
    return this.pendingActivityLoadedForAccount &&
        this.pendingActivityItemsForAccount.length > 0 &&
        !this.isManagedAccount;
  }

  get isManagedAccount (): boolean {
    return this.drivewealthStore.accountsV2Loaded &&
        this.accountTypeKey === InvestmentManagementType.Managed;
  }

  get showCloseAccountButton (): boolean {
    return this.featureFlagStore.flags.bend15911EnableDrivewealthMultiAccountViews && !!this.accountId;
  }


  get showAddAccountButton (): boolean {
    return this.featureFlagStore.flags.bend15911EnableDrivewealthMultiAccountViews &&
        this.drivewealthStore.canOpenAnotherInvestmentAccount;
  }

  get disableCloseButton (): boolean {
    return this.hasInvestmentBalance || this.hasHoldings || this.hasPendingActivity ||
        this.drivewealthStore.closeAccountLoading || this.isCloseButtonDisabled;
  }

  get disableCloseConfirmSubmit (): boolean {
    return this.confirmCloseText !== CloseAccountConfirmationText;
  }

  toggleAccountNumberMask () {
    this.isAccountNumberMasked = !this.isAccountNumberMasked;
  }

  onModalClose (): void {
    this.showConfirmCloseModal = false;
    this.confirmCloseText = "";
  }

  showCloseAccountModal (): void {
    this.showConfirmCloseModal = true;
  }

  confirmCloseAccount (): void {
    this.onCloseAccount();
  }

  onSubmit (): void {
    this.$router.push(
        { name: RouteNames.DrivewealthWizard, params: { step: DrivewealthWizardStep.AccountTypeChange } });
  }

  onCloseAccount (): void {
    this.closeAccountProcessing = true;
    this.drivewealthStore.closeAccount(this.accountId)
        .then(result => {
          this.signingDocumentStore.markDeleteSignature(this.documentKey);
          if (this.drivewealthStore.closeAccountLoaded) {
            this.isCloseButtonDisabled = true;
            useNotifierStore().setSuccess("Account was closed successfully.");
            setTimeout(() => {
              this.$router.push({name: RouteNames.Home, params: { forcePageReload: "true" } });
              this.closeAccountProcessing = false;
            }, 2000);
          }
        }).finally(() => {
          this.onModalClose();
        });
  }

  addInvestmentAccount (): void {
    this.$router.push(
        { name: RouteNames.DrivewealthWizard, params: { step: DrivewealthWizardStep.SelectAccountType } });
  }

  get accountBlurb (): string {
    switch (this.accountTypeKey) {
      case InvestmentManagementType.Managed:
        return "With a managed option, you let the professionals handle your investments for you."
            + "Simply take the risk tolerance questionnaire and your account will be invested according to your "
            + "age and personal risk tolerance. Subsequently, each year on your birthday your account will move "
            + "to a more conservative investment mix.";
      case InvestmentManagementType.Advisory:
        return "With a select option, you build your own investment portfolio from a carefully researched and "
            + "monitored investment list. You have the opportunity to select your own investments from a vetted "
            + "list of approximately 25 exchange traded funds (ETFs).";
      case InvestmentManagementType.SelfDirected:
        return "A choice option is most suited for a more experienced investor who wants to build "
            + "their own portfolio from more than 4,000 individual stocks and exchange  traded funds (ETFs). "
            + "Unlike a select list option, the investment options aren’t researched or monitored in any way.";
      default:
        return "";
    }
  }
}
